export const centered = " flex items-center justify-center ";
export const flexer = " flex items-center justify-between ";
export const errorStyle = " !text-RED !text-left !w-full text-base ";
export const spacer = " m-3 ";
export const hoverFade = " cursor-pointer hover:opacity-80 ";

